import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classes from './SiteNavADesktopLevelB.module.scss';

const SiteNavADesktopLevelB = (props) => {
  const {
    heading,
    subHeading,
    href,
    target,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Link href={href} target={target}>
          <div
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
          {subHeading &&
            <div
              className={classes.subheading}
              dangerouslySetInnerHTML={{ __html: subHeading }}
            />}
        </Link>
      </div>
    </div>
  );
};

SiteNavADesktopLevelB.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
};

export default SiteNavADesktopLevelB;
